import React from "react";
import styled from "styled-components";
import scales from "assets/img/scale-weight.svg";
import EdgePanel from "components/EdgePanel/EdgePanel";

// A orelha e o abre e fecha vivem em EdgePanel. Aqui fica só o conteúdo: a lista
// de balanças, cujo valor é lido do cache mantido por SensorMeasurementSubscribers.
const ScalesList = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  max-height: calc(100vh - 260px);
`;

const Span = styled.span`
  width: 100%;
  border-radius: 10px;
  background-color: #fff;
  color: #2f4050;
  display: inline-block;
  margin-bottom: 14px;
  text-align: center;
`;

const H5 = styled.h5`
  margin-top: 3px;
  margin-bottom: 5px;
`;

const H2 = styled.h2`
  margin-top: 5px;
  margin-bottom: 0px;
  font-weight: bold;
`;

const Sensor = ({ lastMeasurement, name, unit }) => {
  const value = (lastMeasurement != null ? lastMeasurement : 0).toFixed(1);
  const info = unit ? `${value} ${unit}` : lastMeasurement > 0 ? "ON" : "OFF";
  return (
    <Span>
      <H2>
        { info }
      </H2>
      <H5>{ name }</H5>
    </Span>
  );
};

export const SCALES_PANEL_ID = "scales";

export const Sensors = ({ sensorsList }) => (
  <EdgePanel
    id={SCALES_PANEL_ID}
    title="Balanças"
    width={230}
    icon={<img src={scales} alt="Balanças" width="40px" height="40px" />}
  >
    <ScalesList>
      {sensorsList.map((sensor) => (
        <Sensor
          key={sensor.id}
          name={sensor.name}
          unit={sensor.unit}
          lastMeasurement={sensor.lastMeasurement}
        />
      ))}
    </ScalesList>
  </EdgePanel>
);
